// @flow
import React from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { media } from "@nested/rebrand";

const getIcon = (value: "Yes" | "No") =>
  value === "Yes" ? (
    <FontAwesomeIcon color="#3DAD90" size="lg" icon={faCheck} />
  ) : (
    <FontAwesomeIcon color="#CED9DD" size="lg" icon={faTimes} />
  );

const thStyle = css`
  font-weight: 500;
  height: 100px;
  text-align: left;
  white-space: nowrap;
  position: relative;
  ${media.tablet`
    height: auto;
    white-space: normal;
    text-align: center;
    height: 62px;
    line-height: 21px;
  `}
`;

export const Rotate = styled.div`
  transform: rotate(-45deg);
  transform-origin: 0 0;
  position: absolute;
  bottom: 15px;
  left: 0;
  ${media.tablet`
    transform: none;
    position: static;
  `}
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  ${media.tablet`
    margin-top: 40px;
  `}
  ${media.desktop`
    width: calc(100% / 10 * 8);
    margin: auto;
  `}
`;

export const AgentTH = ({ children }: { children: React$Node }) => (
  <th
    css={css`
      ${thStyle}
      font-size: 16px;
    `}
  >
    <div
      css={css`
        position: absolute;
        bottom: 20px;
        left: 0;
      `}
    >
      {children}
    </div>
  </th>
);

export const ComparisonTH = ({ children }: { children: React$Node }) => (
  <th
    css={css`
      ${thStyle}
      font-size: 14px;
      width: 50px;
      ${media.tablet`
        width: 70px;
        padding: 0px 10px;
      `}
    `}
  >
    <Rotate>{children}</Rotate>
  </th>
);

export const TR = styled.tr`
  border-top: 1px solid #ced9dd;
  height: 62px;
`;

export const TD = styled.td`
  padding: 10px 0px;
  line-height: 21px;
  font-size: 16px;
  position: relative;
  text-align: left;
`;

export const IconTD = ({ value }: { value: "Yes" | "No" }) => (
  <td
    css={`
      text-align: center;
    `}
  >
    {getIcon(value)}
  </td>
);

export const FeeTD = ({ children }: { children: React$Node }) => (
  <TD
    css={css`
      font-weight: 500;
      height: 55px;
      position: relative;
      left: 10px;
      ${media.tablet`
        left: 0;
        height: auto;
        text-align: center;
      `}
    `}
  >
    <Rotate>{children}</Rotate>
  </TD>
);

export const FeesHeading = ({ children }: { children: React$Node }) => (
  <TD>
    <div
      css={`
        position: absolute;
        bottom: 35px;
        left: 0;
        ${media.tablet`
          position: static;
        `}
      `}
    >
      {children}
    </div>
  </TD>
);
